import * as auth from "./auth";
import * as db from "./db";
import * as firebase from "./firebase";
import * as store from "./firestore";

const functions = firebase.functions;

export { auth, db, firebase, functions, store };



// WEBPACK FOOTER //
// ./src/firebase/index.js